/**
 * description:
 * File of container Services Container
 *
 * data : 2017-08-03
 */

import Vue from 'vue';
import store from '@/store';
import { mapGetters, mapActions } from 'vuex';
import _groupBy from 'lodash.groupby';
import moment from 'moment';

// COMPONENTS //////////////////////////////////////////////////////////////////
// eslint-disable-next-line import/extensions,import/no-unresolved
import RpcNotAvailable from '@/components/Services/RpcNotAvailable';
import ServiceCategory from '@/components/Services/ServiceCategory';
import ServiceCategoryTitle from '@/components/Services/ServiceCategoryTitle';
import ServiceBanner from '@/components/Services/ServiceBanner';
import FeatureTile from '@/components/Services/FeatureTile';
import CategoryLayout from '@/components/Help/CategoryLayout';
import SmartColumnLayout from '@/components/Help/SmartColumnLayout';
import { hDeepCopy } from '@/utils/helpers';
// CONTAINER ///////////////////////////////////////////////////////////////////
const Services = {
  components: { RpcNotAvailable, CategoryLayout, SmartColumnLayout, ServiceCategory, ServiceCategoryTitle, ServiceBanner, FeatureTile },
  store,
  data() {
    return {
      isRpcAvailable: true,
    };
  },
  computed: {
    ...mapGetters(['servicesList',
      'servicesBanners',
      'hasServiceStatusBeenChange',
      'subscriber',
      'pendingStoreActions',
      'responseCode',
      'servicesListLoading',
      'changeStatusLoading',
      'confirmationRequired',
      'enabled',
      'incorrect_code',
      'selectedCategory',
    ]),
    servicesFilter() {
      let sortedList = hDeepCopy(this.servicesList).sort((a, b) => a.order - b.order);
      let groupedByName = _groupBy(sortedList, 'services_categories_name');
      let groupedAndOrdered = {};
      Object.keys(groupedByName).forEach((category) => {
        groupedAndOrdered[category] = {
          order: groupedByName[category][0].services_categories_order,
          icon: groupedByName[category][0].icon,
          list: groupedByName[category],
        };
      });

      return groupedAndOrdered;
    },
    bannersFilter() {
      let sortedList = hDeepCopy(this.servicesBanners).sort((a, b) => a.order - b.order);
      let groupedByCategory = _groupBy(sortedList, 'services_categories_name');

      return groupedByCategory;
    },
    packagesFilter() {
      const packagesList = hDeepCopy(this.servicesList).filter(obj => obj.feature_type === 'Promotion' && obj.date !== null);
      return packagesList.sort((a, b) => moment(b.date) - moment(a.date));
    },
    category() {
      if (this.servicesFilter[this.selectedCategory]) {
        return this.servicesFilter[this.selectedCategory];
      }
      return null;
    },
  },
  watch: {
    responseCode(newValue) {
      this.isRpcAvailable = true;
      if (newValue !== 200) {
        this.isRpcAvailable = false;
        this.$EventBus.$emit('Services/CLOSE_MODAL');
        const nowDate = moment();
        const stopDate = moment(nowDate).add(1, 'minutes');
        const data = {
          isBlocked: true,
          timestamp: stopDate,
        };
        localStorage.setItem('rpcAccess', JSON.stringify(data));
      }
    },
  },
  methods: {
    ...mapActions(['getServicesList', 'changeStatus', 'clearChangeStatusResult']),
    async handleRefresh() {
      this.isRpcAvailable = true;
      await this.getServicesList();
            // eslint-disable-next-line eqeqeq
      if (this.responseCode == 200) {
        this.isRpcAvailable = true;
      } else {
        this.isRpcAvailable = false;
      }
    },
  },
  mounted() {

  },
  created() {
    if (localStorage.getItem('rpcAccess') === null) {
            // eslint-disable-next-line eqeqeq
      if (this.responseCode == 200) {
        this.getServicesList();
      }
    } else {
      this.isRpcAvailable = false;
    }
  },
  template: `
        <div class="container-fluid animated fadeIn modal-handler">
            <div class="Card__loading-container"
                 style="min-height: 100%;"
                 v-if="servicesListLoading || changeStatusLoading"
            >
                <div class="loading-container__loading-message">
                    <i class="fa fa-spinner fa-spin" aria-hidden="true"></i>
                </div>
            </div>
            <div v-if="isRpcAvailable">
                <div v-if="!category" class="mobile-content">
                    <ServiceCategoryTitle :title="'Internet'" v-if="subscriber.type === 'postpaid' && !servicesListLoading"/>
                    <CategoryLayout v-if="subscriber.type === 'postpaid' && !servicesListLoading">
                        <div slot="item"
                            v-for="(serviceCategory, index) in servicesFilter"
                            v-if="serviceCategory.list[0].prepaid === false"
                            class="CategoryLayout__item"
                            :class="{'CategoryLayout__item--hidden': serviceCategory.list[0].feature_type === 'Promotion'}"
                            :key="index"
                        >
                            <ServiceCategory
                                v-if="serviceCategory.list[0].feature_type !== 'Promotion'"
                                :title="index"
                                :icon="serviceCategory.icon"
                            />
                        </div>
                    </CategoryLayout>
                    <ServiceCategoryTitle :title="'Usługi i blokady'" v-if="!servicesListLoading" />
                    <CategoryLayout v-if="!servicesListLoading">
                        <div slot="item"
                            v-for="(serviceCategory, index) in servicesFilter"
                            v-if="serviceCategory.list[0].prepaid === true"
                            class="CategoryLayout__item"
                            :class="{'CategoryLayout__item--hidden': serviceCategory.list[0].feature_type === 'Promotion'}"
                            :key="index"
                        >
                            <ServiceCategory
                                v-if="serviceCategory.list[0].feature_type !== 'Promotion'"
                                :title="index"
                                :icon="serviceCategory.icon"
                            />
                        </div>
                    </CategoryLayout>
                </div>
                <div class="mobile-content" v-else>
                    <ServiceCategoryTitle
                      :title="category.list[0].category_name"
                      :show_return="true"
                    />
                    <SmartColumnLayout>
                        <div slot="item" v-for="(feature, index) in category.list">
                            <FeatureTile :service="feature" :hide_price="feature.feature_type === 'Service Blockade'"/>
                        </div>
                        <div slot="item" v-for="(banner, index) in bannersFilter[selectedCategory]">
                            <ServiceBanner :banner="banner" />
                        </div>
                    </SmartColumnLayout>
                </div>
            </div>
            <div v-else>
                <RpcNotAvailable @refresh="handleRefresh"/>
            </div>
        </div>
    `,
};

export default Vue
    .component('Services', Services);



// WEBPACK FOOTER //
// ./src/containers/Services/index.js